/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Reverser — Reverse Characters, Words & Lines | Toolverse`)
};

const es_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversor de Texto — Invierte Caracteres, Palabras y Líneas | Toolverse`)
};

const de_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Reverser — Zeichen, Wörter & Zeilen umkehren | Toolverse`)
};

const nl_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekstomdraaier — Tekens, woorden en lijnen omdraaien | Toolverse`)
};

const fr_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverseur de texte — Inverser les caractères, mots et lignes | Toolverse`)
};

const it_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invertitore di Testo — Inverti Caratteri, Parole e Righe | Toolverse`)
};

const pt_br2_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversor de Texto — Inverta Caracteres, Palavras e Linhas | Toolverse`)
};

const pt_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversor de Texto — Inverta Caracteres, Palavras e Linhas | Toolverse`)
};

const ja_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストリバーサー — 文字、単語、行を反転 | Toolverse`)
};

const zh_rv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本反转器 — 反转字符、单词与行 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_meta_title", locale)
	if (locale === "en") return en_rv_meta_title(inputs)
	if (locale === "es") return es_rv_meta_title(inputs)
	if (locale === "de") return de_rv_meta_title(inputs)
	if (locale === "nl") return nl_rv_meta_title(inputs)
	if (locale === "fr") return fr_rv_meta_title(inputs)
	if (locale === "it") return it_rv_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_rv_meta_title(inputs)
	if (locale === "pt") return pt_rv_meta_title(inputs)
	if (locale === "ja") return ja_rv_meta_title(inputs)
	return zh_rv_meta_title(inputs)
};